

export default class Regexp {

    static _EMAIL = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i;
    static _MOBILE_NUMBER = /^(\+\d{1,2}\s?)?\(?0?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/; // Old One => /^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
    static _PASSWORD = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
}
